import { ReactNode } from 'react';

interface Props {
  pageTitle: string;
  children: ReactNode;
  pageSubTitle?: string;
}

export const WizardStep = ({ pageTitle, children, pageSubTitle }: Props) => {
  return (
    <div className="step-content w-100 mt-3 flex-grow-1 d-flex flex-column">
      <div>
        <div className="title">{pageTitle}</div>
        <div className="description">{pageSubTitle}</div>
      </div>
      <div className="flex-grow-1 d-flex flex-column justify-content-between">
        {children}
      </div>
    </div>
  );
};
